import GLightbox from 'glightbox';
import { OverlayScrollbars } from 'overlayscrollbars';

// Initialize GLightbox for team popups
document.addEventListener('DOMContentLoaded', function() {
    // Initialize GLightbox with proper configuration
    const lightbox = GLightbox({
        selector: '.glightbox-team',
        touchNavigation: false, // Disable touch navigation
        loop: false,
        autoplayVideos: false,
        openEffect: 'fade',
        closeEffect: 'fade',
        closeButton: false,
        // Disable arrows
        showNavigation: false,
        // Disable unnecessary features
        draggable: false,
        zoomable: false
    });

    // Add custom close button functionality
    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('close-modal')) {
            lightbox.close();
        }
    });

    // Initialize OverlayScrollbars on description elements when lightbox content is loaded
    lightbox.on('slide_after_load', function(data) {
        // Find all description elements inside lightbox content
        const descriptionElements = document.querySelectorAll('.team-popup-content .description');

        // Check if screen width is at least 792px
        const isLargeScreen = window.innerWidth >= 792;

        if (isLargeScreen) {
            // Initialize OverlayScrollbars only on larger screens
            descriptionElements.forEach(element => {
                OverlayScrollbars(element, {
                    scrollbars: {
                        autoHide: 'never',
                    },
                    overflow: {
                        x: 'hidden',
                        y: 'scroll'
                    }
                });
            });
        }

        // Make sure close buttons work
        const closeButtons = document.querySelectorAll('.close-modal');
        closeButtons.forEach(button => {
            button.addEventListener('click', function() {
                lightbox.close();
            });
        });
    });

    // Handle window resize to add or remove OverlayScrollbars
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            const isLargeScreen = window.innerWidth >= 792;
            const descriptionElements = document.querySelectorAll('.team-popup-content .description');

            descriptionElements.forEach(element => {
                const osInstance = OverlayScrollbars.get(element);

                if (isLargeScreen && !osInstance) {
                    // Initialize OverlayScrollbars if screen is large and not already initialized
                    OverlayScrollbars(element, {
                        scrollbars: {
                            autoHide: 'never',
                        },
                        overflow: {
                            x: 'hidden',
                            y: 'scroll'
                        }
                    });
                } else if (!isLargeScreen && osInstance) {
                    // Destroy OverlayScrollbars if screen is small and it's initialized
                    osInstance.destroy();
                }
            });
        }, 200); // Debounce resize events
    });
});
